import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"
import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import type {CurveLikeNode} from "#template/nodes/object/curve/fundamental"
import {curveLikeMarker} from "#template/nodes/object/curve/fundamental"
import type {NodeEvaluator} from "#template/node-evaluator"
import {ObjectNode} from "#template/nodes/object/object-node"
import type {ObjectNodeConstructorParameters, ObjectNodeParameters} from "#template/nodes/object/types"
import type {CurveData, CurveObjectData} from "#template/nodes/object/curve/types"

export abstract class CurveNode<
        out Parameters extends ObjectNodeParameters = ObjectNodeParameters,
        out ConstructorParameters extends ObjectNodeConstructorParameters = Omit<Parameters, "visible"> & {visible?: boolean},
    >
    extends ObjectNode<Parameters, ConstructorParameters>
    implements CurveLikeNode
{
    get [curveLikeMarker]() {
        return true as const
    }

    public override evaluate(scope: GraphBuilderScope, evaluator: NodeEvaluator): BuilderInlet<CurveObjectData | null> {
        const objectData = super.evaluate(scope, evaluator)
        const curveData = scope.unresolvedToNull(evaluator.templateScope.resolve<CurveData | null>(`curveData-${evaluator.getLocalId(this)}`))

        return scope.pureLambda(
            scope.tuple(objectData, curveData),
            ([objectData, curveData]) => {
                if (objectData === null || curveData === null) return null
                return {
                    ...objectData,
                    ...curveData,
                }
            },
            "evaluatedCurve",
        )
    }
}
